import { Stack, Typography } from '@mui/material'
import { fontWeight } from '@mui/system'
import React from 'react'
import Icon from '../assets/icons/gym.png'
const BodyPart = ({item,bodyPart,setBodyPart}) => {
  return (
   <Stack border='2px solid black' type="button" alignItems="center" justifyContent="center" className='bodyPart-card'
        sx={{
           borderTop: bodyPart===item ? '4px solid #ff2625': '',
            borderBottomLeftRadius:'10px',
            borderBottomRightRadius:'10px',
            backgroundColor: '#fff',
            width:'8vw',
            height:'12vh',
            cursor:'pointer',
            gap:'5%'
        }}
        onClick={()=>setBodyPart(item)}
           
   >
      <img src={Icon}  alt="dumbel" style={{width:"40%" , height: "40%",margin:"auto"}}/>
      <Typography sx={{fontWeight:"900",fontSize:"0.6rem",margin:"auto"}}>{item}</Typography>
    </Stack>
  )
}

export default BodyPart